import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class AdminMenuService {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();

    changeMessage(message: any): void {
        this.messageSource.next(message);
    }

}
